function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M26.9,72.4h-1.3c-1.2,0-2.3-.6-3.3-1-.3,0-.6-.3-.9-.4-1-.4-1.5-1.4-1.1-2.4s1.4-1.5,2.4-1.1c.3,0,.7.3,1.1.4.8.3,1.7.7,2.4.8,2.7.3,4.7-.9,7.1-2.3,2.6-1.6,5.5-3.4,9.6-2.7,2,.3,4.2,1.5,6.3,2.7,1.4.8,2.9,1.6,4,1.9,3.7,1.1,5.7,0,8.2-1.7,2.1-1.3,4.4-2.8,7.8-2.9,3.4,0,6.7,1.6,9.6,3,1.8.9,3.6,1.8,4.8,2,1.4.2,3.3-.4,4.6-1.1.9-.5,2.1,0,2.5.8.5.9,0,2.1-.8,2.5-1.1.5-4,1.8-6.7,1.4-1.9-.2-3.9-1.3-6.1-2.4-2.6-1.3-5.4-2.7-7.7-2.6-2.4,0-4.1,1.2-6,2.3-2.8,1.8-5.9,3.7-11.3,2.1-1.4-.4-3-1.3-4.7-2.2-1.8-1-3.8-2.1-5.1-2.3-2.7-.4-4.7.8-7,2.2-2.3,1.4-4.8,2.9-8.2,2.9h-.2Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M21.1,55.6c0,1.2,1,2.2,2.2,2.2h63.5c1.2,0,2.2-1,2.2-2.2h0c0-1.2-1-2.2-2.2-2.2H23.3c-1.2,0-2.2,1-2.2,2.2h0Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M36.5,84.9c1.6,0,2.8,1.3,2.8,2.8s-1.3,2.8-2.8,2.8-2.8-1.3-2.8-2.8,1.3-2.8,2.8-2.8ZM68.2,84.8c1.6,0,2.8,1.3,2.8,2.8s-1.3,2.8-2.8,2.8-2.8-1.3-2.8-2.8,1.3-2.8,2.8-2.8ZM54.7,78.5c1.6,0,2.8,1.3,2.8,2.8s-1.3,2.8-2.8,2.8-2.8-1.3-2.8-2.8,1.3-2.8,2.8-2.8ZM81.4,78.5c1.6,0,2.8,1.3,2.8,2.8s-1.3,2.8-2.8,2.8-2.8-1.3-2.8-2.8,1.3-2.8,2.8-2.8ZM27.3,77.3c1.6,0,2.8,1.3,2.8,2.8s-1.3,2.8-2.8,2.8-2.8-1.3-2.8-2.8,1.3-2.8,2.8-2.8ZM41.2,74.2c1.6,0,2.8,1.3,2.8,2.8s-1.3,2.8-2.8,2.8-2.8-1.3-2.8-2.8,1.3-2.8,2.8-2.8ZM71.3,72.3c1.6,0,2.8,1.3,2.8,2.8s-1.3,2.8-2.8,2.8-2.8-1.3-2.8-2.8,1.3-2.8,2.8-2.8Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M47.7,39.1c-7.6.9-9.5,2.9-10.5,10.5,0,.7-1,.7-1.1,0-.9-7.6-2.9-9.5-10.5-10.5-.7,0-.7-1,0-1.1,7.6-.9,9.5-2.9,10.5-10.5,0-.7,1-.7,1.1,0,.9,7.6,2.9,9.5,10.5,10.5.7,0,.7,1,0,1.1Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M84.8,29.4c-10,1.2-12.5,3.8-13.7,13.7-.1.9-1.3.9-1.4,0-1.2-10-3.8-12.5-13.7-13.7-.9-.1-.9-1.3,0-1.4,10-1.2,12.5-3.8,13.7-13.7.1-.9,1.3-.9,1.4,0,1.2,10,3.8,12.5,13.7,13.7.9.1.9,1.3,0,1.4Z"
});

var SvgIcoSimulationCategorySkin = function SvgIcoSimulationCategorySkin(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 110 110",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoSimulationCategorySkin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_simulation_category_skin.b2a3b05c.svg";
export { ForwardRef as ReactComponent };